import React from "react";
import { track } from "@/lib/analytics";

export default function ComboStrip({ combo }) {
  if (!combo?.enabled) return null;
  const price = Number(combo.surcharge || 0).toFixed(2).replace(".", ",");
  const onClick = () => {
    track("combo_click", { surcharge: combo.surcharge });
    document.getElementById("ordina")?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  return (
    <button
      type="button"
      onClick={onClick}
      className="mt-8 w-full sm:w-auto inline-flex flex-wrap items-center gap-x-4 gap-y-1 rounded-full border-2 border-[#FFC20E] px-6 py-3 text-left hover:bg-[#FFC20E] group transition-colors duration-200"
      data-testid="combo-cta"
    >
      <span className="font-display font-black uppercase text-xl sm:text-2xl text-[#FFC20E] group-hover:text-[#0C0C0C] leading-none">
        {combo.title || "FALLA COMBO"} +{price}
      </span>
      <span className="font-display font-bold uppercase tracking-wide text-sm text-white/80 group-hover:text-[#0C0C0C]" data-testid="combo-copy">
        {combo.copy}
      </span>
    </button>
  );
}
